var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { utilEnvironment } from "../../utils/utilEnvironment";
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.formatComponentStack = function (str) {
            var lines = str.split(/\s*\n\s*/g);
            var ret = "";
            for (var line = 0, len = lines.length; line < len; line++) {
                if (lines[line].length) {
                    ret += "" + (ret.length ? "\n" : "") + lines[line];
                }
            }
            return ret;
        };
        _this.state = {
            error: null,
            hasError: false,
            info: null,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        // Display fallback UI
        this.setState({ error: error, hasError: true, info: info });
        var _a = this.props, client = _a.client, beforeSend = _a.beforeSend, name = _a.name;
        var BugsnagReport = client.BugsnagReport;
        var handledState = {
            severity: "error",
            severityReason: { type: "unhandledException" },
            unhandled: true,
        };
        var report = new BugsnagReport(error.name, "" + error.message, BugsnagReport.getStacktrace(error), handledState);
        if (info && info.componentStack) {
            info.componentStack = this.formatComponentStack(info.componentStack);
        }
        client.notify(report, {
            beforeSend: beforeSend,
            metaData: { react: info, notifyContext: "ErrorBoundary(" + name + ")" },
        });
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            var error = this.state.error;
            if (error) {
                var fallbackUI = this.props.fallbackUI;
                if (fallbackUI) {
                    return fallbackUI;
                }
            }
            if (!utilEnvironment.isProduction()) {
                var style = {
                    backgroundColor: "black",
                    color: "red",
                };
                return React.createElement("h1", { style: style }, "Component tree crashed.");
            }
            return null;
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/ErrorBoundary.tsx
// module id = 208
// module chunks = 3